import React from "react";
import { Loader } from "../root/loader";
import { WorkspaceIntermediarySettings } from "./components/intermediary_settings";

export const intermediaries = () => [
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: "/details/:workspaceId/intermediaries/wizard",
            element: (
                <Loader>
                    <WorkspaceIntermediarySettings view="CREATE" />
                </Loader>
            )
        }
    },
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: "/details/:workspaceId/intermediaries/:intermediaryTaxId/wizard/:step",
            element: (
                <Loader>
                    <WorkspaceIntermediarySettings view="CREATE" />
                </Loader>
            )
        }
    },
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: "/details/:workspaceId/intermediaries/:intermediaryTaxId/edit",
            element: (
                <Loader>
                    <WorkspaceIntermediarySettings view="EDIT" />
                </Loader>
            )
        }
    },
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: "/details/:workspaceId/intermediaries/:intermediaryTaxId/edit/:step",
            element: (
                <Loader>
                    <WorkspaceIntermediarySettings view="EDIT" />
                </Loader>
            )
        }
    }
];
